import { makeStyles } from "@material-ui/core/styles";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    dropdown: {
      display: "flex",
      flexGrow: 0,
      marginLeft: theme.spacing(3)
    },
    dropdownWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: theme.spacing(3)
    }
  }),
  { name: "DropdownWrapper" }
);

interface SaleSellerDropdownProps {
  brand: string;
  brandChoices: SingleAutocompleteChoiceType[];
  brandLabel: string;
  brandDisabled?: boolean;
  onBrandChange: (e) => void;
}

const SaleSellerDropdown: React.FC<SaleSellerDropdownProps> = props => {
  const {
    brand,
    brandChoices,
    brandLabel,
    brandDisabled,
    onBrandChange
  } = props;

  const { dropdown, dropdownWrapper } = useStyles(props);
  const intl = useIntl();

  return (
    <div className={dropdownWrapper}>
      {brandLabel ? (
        <SingleAutocompleteSelectField
          label={intl.formatMessage({
            defaultMessage: "Seller (Brand)*"
          })}
          className={dropdown}
          name="brandDropdown"
          displayValue={brandLabel}
          choices={brandChoices}
          value={brand}
          onChange={onBrandChange}
          disabled={brandDisabled}
        />
      ) : (
        <SingleAutocompleteSelectField
          label={intl.formatMessage({
            defaultMessage: "Seller (Brand)*"
          })}
          className={dropdown}
          name="brandDropdown"
          displayValue={""}
          choices={[]}
          value={""}
          onChange={onBrandChange}
          disabled
        />
      )}
    </div>
  );
};

export default SaleSellerDropdown;
